// https://fluentsite.z22.web.core.windows.net/quick-start
import { Loader } from '@fluentui/react-northstar'
import { BrowserRouter, Redirect, Route } from 'react-router-dom'
import { useTeamsFx } from '@microsoft/teamsfx-react'
import { TeamsTheme } from '@fluentui/react-teams/lib/cjs/themes'
import { Provider } from '@fluentui/react-teams'
import {
  Capture,
  ErrorNotification,
  BadConditions,
  Results,
} from 'tabs/CaptureTab/Views'
import './App.scss'
import { Login } from 'tabs/CaptureTab/Views/Login/login'
import VerifyUser from 'tabs/CaptureTab/Views/Verify/Verify'
import { UserProvider } from 'context/useAuth'
import ProtectedRoute from 'ProtectedRoute'

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const { loading } = useTeamsFx()
  return (
    
    // <TeamsFxContext.Provider value={{theme, themeString, teamsfx}}>
      <UserProvider>
      <Provider themeName={TeamsTheme.Default} lang="en-US">
        <BrowserRouter>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <Route path={'/login'} component={Login} />
          <Route path={'/verification'} component={VerifyUser} />
          {loading ? (
            <Loader style={{ margin: 100 }} />
          ) : (

              <Route path="/capture" render={({ match: { url } }) => (
                <>
                  <ProtectedRoute exact path={`${url}/`} component={Capture} />
                  <ProtectedRoute exact path={`${url}/error`} component={ErrorNotification} />
                  <ProtectedRoute exact path={`${url}/bad-conditions`} component={BadConditions} />
                  <ProtectedRoute exact path={`${url}/results`} component={Results} />
                </>
              )} />
              
            
          )}
        </BrowserRouter>
      </Provider>
      </UserProvider>
    // </TeamsFxContext.Provider>
    
  )
}
